import VDatePicker from './VDatePicker';
import VDatePickerTitle from './VDatePickerTitle';
import VDatePickerHeader from './VDatePickerHeader';
import VDatePickerDateTable from './VDatePickerDateTable';
import VDatePickerMonthTable from './VDatePickerMonthTable';
import VDatePickerYears from './VDatePickerYears';
export { VDatePicker, VDatePickerTitle, VDatePickerHeader, VDatePickerDateTable, VDatePickerMonthTable, VDatePickerYears };
export default {
    $_vuetify_subcomponents: {
        VDatePicker: VDatePicker,
        VDatePickerTitle: VDatePickerTitle,
        VDatePickerHeader: VDatePickerHeader,
        VDatePickerDateTable: VDatePickerDateTable,
        VDatePickerMonthTable: VDatePickerMonthTable,
        VDatePickerYears: VDatePickerYears
    }
};
//# sourceMappingURL=index.js.map